import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import _ from "lodash"
import { all } from "rsvp"

export default class PlanbookStandardsRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return get(this, "store")
      .find("planbook", params.planbook_id)
      .then((planbook) => {
        let coursePromises = _.map(planbook.relationships.courses.data, (datum) =>
          get(this, "store").find("course", datum.id)
        )
        return all(coursePromises).then((courses) => {
          return { planbook, courses }
        })
      })
    // return
  }
}
